<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm" style="height: max-content; width: 50rem; padding: 1rem 2rem; border-radius: 5px;" @click.stop>
            <div>
                <h3>Editar: {{ tarefa?.codigo }} </h3>
            </div>
            <hr>
            <br>
            <div class="grid-2">
                <div>
                    <label>Descrição</label>
                    <textarea v-model="localTarefa.descricao" :readonly="finalizado"
                        @focusout="$emit('editar', 'descricao', localTarefa.id, localTarefa.descricao)"></textarea>
                </div>
                <div>
                    <label>Responsável</label>
                    <select v-model="localTarefa.responsavel_id" :disabled="finalizado"
                        @change="$emit('editar', 'responsavel_id', localTarefa.id, localTarefa.responsavel_id)">
                        <option v-for="item in gerente" :key="item.id" :value="item.id"> {{ item.nomeCompleto }}
                        </option>
                    </select>
                </div>
                <div class="grid-2">
                    <div>
                        <label>Início Previsto</label>
                        <input v-model="localTarefa.dtInicio" type="date" :readonly="finalizado"
                            @change="$emit('editar', 'dtInicio', localTarefa.id, (localTarefa.dtInicio + ' ' + dataHora))">
                    </div>
                    <div>
                        <label>Fim Previsto</label>
                        <input v-model="localTarefa.dtFim" type="date" :readonly="finalizado"
                            @change="$emit('editar', 'dtFim', localTarefa.id, (localTarefa.dtFim + ' ' + dataHora))">
                    </div>
                    <div>
                        <label>Inicio Real</label>
                        <input v-model="localTarefa.dtInicioReal" type="date" :readonly="finalizado"
                            @change="$emit('editar', 'dtInicioReal', localTarefa.id, (localTarefa.dtInicioReal + ' ' + dataHora))">
                    </div>
                    <div>
                        <label>Fim Real</label>
                        <input v-model="localTarefa.dtFimReal" type="date" :readonly="finalizado"
                            @change="$emit('editar', 'dtFimReal', localTarefa.id, (localTarefa.dtFimReal + ' ' + dataHora))">
                    </div>
                </div>
                <div>
                    <label>Observações</label>
                    <textarea v-model="localTarefa.obs" rows="6" :readonly="finalizado"
                        @focusout="$emit('editar', 'obs', localTarefa.id, localTarefa.obs)"></textarea>
                </div>
                <div class="col-2" style="margin-bottom: 0;">
                    <span>
                        Anexos:
                        <i v-if="!finalizado" title="Adicionar anexo" style="font-size: 15px; cursor: pointer; margin-left: 0.5rem;"
                            class="bi bi-plus-circle" @click="openFileInput"></i>
                    </span>
                    <input style="display: none;" ref="fileInput" type="file" multiple @change="onFileChange">
                    <ul style="list-style: none; margin-bottom: 0; margin-top: 0.5rem;" class="grid-3">
                        <li v-for="item in (tarefa?.anexos ?? [])" :key="item.id">
                            <div class="anexo">
                                <a :href="urlFoto.caminhoFoto + (item.path || item.anexo)" target="_blank">
                                    {{ item.nome ?? '-' }}
                                </a>
                                <i v-if="!finalizado" @click="$emit('excluirAnexo', item.id)" style="color: red"
                                    class="bi bi-trash-fill botaoAdicionarSprint"></i>
                            </div>
                        </li>
                        <div v-if="!finalizado" @click="openFileInput" style="cursor: pointer" class="anexo">
                            Adicionar <i title="Adicionar anexo" class="bi bi-plus-circle"></i>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataHoraAgora } from "@/utils/date";
import { urlFoto } from "@/services/api";

export default {
    name: "ModalEditarTarefaProtocolo",
    props: {
        mostrar: { type: Boolean, default: false },
        tarefa: { type: Object, default: () => ({ anexos: [] }) },
        gerente: { type: Array, default: () => [] },
        finalizado: { type: Boolean, default: false },
    },
    emits: ["fechar", "editar", "excluirAnexo", "uploadAnexos"],
    data() {
        return {
            localTarefa: {},
            dataHora: "",
            urlFoto,
        };
    },
    watch: {
        tarefa: {
            handler(val) {
                this.localTarefa = val ? { ...val } : {};
            },
            immediate: true,
            deep: true,
        },
        mostrar(visivel) {
            if (visivel && this.tarefa) {
                this.localTarefa = { ...this.tarefa };
                this.dataHora = dataHoraAgora();
            }
        },
    },
    methods: {
        openFileInput() {
            this.$refs.fileInput?.click();
        },
        onFileChange(e) {
            const files = e.target?.files;
            if (files?.length) {
                this.$emit("uploadAnexos", files);
            }
            e.target.value = "";
        },
    },
};
</script>
